module.exports = __webpack_public_path__ + "static/img/img_basicInfo_avatar.50d93c77.png";